function Footnotes(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */

	
	/* PRIVATE VARIABLES */
	var footnoteList;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function footnoteBlinkEffect(fLink){
		// alternate two animation classes to properly restart css animation
		if(fLink.hasClass('blink')) {
			fLink.removeClass('blink').delay(50).addClass('blink-restart');
		} else {
			fLink.removeClass('blink-restart').delay(50).addClass('blink');
		}
	}
	
	
	function initFootnoteIndexes(){
		$('a.footnote').each(function(index) {
			var fLink = $(this);
			var id = fLink.attr('href');
			var fTarget = $(id, footnoteList);
			var fContent;
			
			// scroll footnotes to indexes
			if (fTarget.length === 1) {
				fContent = fTarget.clone().html();
				fTarget.click(function (e) {
					e.preventDefault();
					NavigationUtils.scrollToElement(fLink, -10);
					// blink the index icon after scroll
					setTimeout(function(){
						footnoteBlinkEffect(fLink);
					}, 250);
				});
				
				// add content text to native link title
				fLink.attr('title', fTarget.text());		
			}
			
			// show footnote detail next to index icon
			if(fContent) {
				var detail = $('<span class="footnote-detail">');
				detail.append(fContent);
				fLink.after(detail);
				fLink.click(function (e) {
					e.preventDefault();
					detail.toggleClass('visible');
				});	
			}
		});
	}
	
	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			footnoteList = $('ol#footnotes', _this.container);
		   
			// handlers		
			
			// init
			initFootnoteIndexes();

			
			_this.inited = true;
		}
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
